import * as actions from './form.actions';
import { Form } from './form.model';
import { State } from './form.reducer';

export const updateFromApiReducer = (
    state: State,
    action: actions.UpdateFromApi
): State => {

    return (action.payload.form || [])
        .reduce((s, remote) => {

            const local = s.entities[remote.id];

            // the remote object does not exist locally
            if (!local) {
                s.ids = [...s.ids, remote.id];
                s.entities[remote.id] = new Form(remote);
                return s;
            }

            if (remote.serverModified > local.serverModified) {
                s.entities[remote.id] = new Form(remote);
            }
            return s;
        }, {
            ...state,
            // we need to clone the objects to avoid Object.lock errors
            ids: [...state.ids],
            entities: {...state.entities}
        } as State);
};



// WEBPACK FOOTER //
// ./src/vas/business-objects/form/update-from-api.reducer.ts